<template>
  <div class="container">
    <v-suburb v-show="ifSuburb" @change="changeSuburb" @close="suburbClose()"></v-suburb>
    <div class="main" v-show="!ifSuburb">
        <div class="navi">
            <span class="close"><span class="icon-arrow-left" @click="goBack()"></span></span>
            <div class="top-title">钟点工服务</div>
            <span></span>
        </div>
        <div class="logo"><img src="../../../assets/img/index/logohf.svg"></div>
        <div class="core">
            <h2>预定钟点工</h2>
            <div class="notice-box" v-show="ifHoliday()">
                <div class="notice-yellow">
                    {{holidayWord()}}
                </div>
            </div>
            <div v-show="nextStep">
                <div class="weui-cells__title">联系信息</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">联系人</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="请输入您的名字" v-model="data.username"> 
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd">
                            <label class="weui-label">联系手机</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="tel" placeholder="请输入您的手机号" v-model="data.userphone">
                        </div>
                    </div>
                </div>
                <div class="notice-yellow form">
                最后一步，请填写联系信息，我们客服收到后会尽快给您电话回访确认服务细节
                </div>
                <br>
            </div>
            <div v-show="!nextStep">
                <div class="weui-cells__title" >服务详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">服务类型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="1" selected>日常保洁</option>
                            </select>
                        </div>
                    </div>

                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">服务时间</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：14:00-16:00" v-model="data.service_time">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">服务频次</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.service_date">
                                <option value="" selected disabled>点击选择</option>
                                <option value="一周一次">一周一次</option>
                                <option value="两周一次">两周一次</option>
                                <option value="sp">一周多次</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after" v-if="data.service_date=='sp'">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">每周次数</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.service_date_sp">
                                <option value="" selected disabled>点击选择</option>
                                <option value="一周2次">2次</option>
                                <option value="一周3次">3次</option>
                                <option value="一周4次">4次</option>
                                <option value="一周5次">5次</option>
                                <option value="一周6次">6次</option>
                                <option value="一周7次">7次</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title" >房屋详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">房屋类型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3" v-model="data.house">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1">Apartment</option>
                                <option value="2">Unit</option>
                                <option value="3">House</option>
                                <option value="4">Town House</option>
                                <option value="5">Studio</option>
                                <option value="6">Other</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">房屋户型</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select4" v-model="data.layout">
                                <option value="" selected disabled>点击选择</option>
                                <option value="2">一室一卫</option>
                                <option value="3">两室一卫</option>
                                <option value="4">两室两卫</option>
                                <option value="5">三室一卫</option>
                                <option value="6">三室两卫</option>
                                <option value="7">其他户型</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">房屋面积</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="（选填）"  v-model="data.square">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd">
                            <label for="" class="weui-label">能否停车</label>
                        </div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select3"  v-model="data.parking">
                                <option value="" selected disabled>点击选择</option>
                                <option value="1">方便停车</option>
                                <option value="2">不便停车</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">地址详情</div>
                <div class="weui-cells weui-cells_form" >
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label">Street</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：Unit 2, 9 Hunter St"  v-model="data.address_street">
                        </div>
                    </div>
                    <div class="weui-cell weui-cell_access padding-fix"  @click="suburbSelect()">
                        <div class="weui-cell__hd">
                            <label class="weui-label">Suburb</label>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb==''"> 
                            <p class="placeholder-color">如：Chatswood</p>
                        </div>
                        <div class="weui-cell__bd" v-if="data.address_suburb!=''"> 
                            <p>{{data.address_suburb}}</p>
                        </div>
                        <div class="weui-cell__ft"></div>
                    </div>
                    <div class="weui-cell weui-cell_select weui-cell_select-after">
                        <div class="weui-cell__hd"><label class="weui-label">State</label></div>
                        <div class="weui-cell__bd">
                            <select class="weui-select" name="select2" >
                                <option value="NSW" selected>NSW</option>
                            </select>
                        </div>
                    </div>
                    <div class="weui-cell" >
                        <div class="weui-cell__hd"><label class="weui-label">Postcode</label></div>
                        <div class="weui-cell__bd">
                            <input class="weui-input" type="text" placeholder="如：2000"  v-model="data.address_postcode">
                        </div>
                    </div>
                </div>
                <div class="weui-cells__title">留言备注</div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__bd">
                            <textarea class="weui-textarea" placeholder="告诉我们更多需求，以便找到最合适您的钟点工。您选择了一周多次的服务频次，请问您希望每周的哪几天上门？" rows="3" v-model="data.message" v-if="data.service_date=='sp'"></textarea>
                            <textarea class="weui-textarea" placeholder="告诉我们更多需求，以便找到最合适您的钟点工。" rows="3" v-model="data.message" v-if="data.service_date!='sp'"></textarea>
                        </div>
                    </div>
                </div>
            <br>
            </div>
        </div>
        <div class="btn-box-fix">
            <div class="btn-container">
                <div class="btn active" @click="submitOrder()">立即下单</div>
            </div>
        </div>
    </div>
    <div v-show="localErrorShow">
        <div class="weui-mask"></div>
        <div class="weui-dialog">
            <div class="weui-dialog__bd">{{localError[0]}}</div>
            <div class="weui-dialog__ft">
                <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="localErrorShow=false">好的</a>
            </div>
        </div>
    </div>
    <transition name="fade">
        <div id="loadingToast" v-show="isSending">
            <div class="weui-mask_transparent"></div>
            <div class="weui-toast">
                <i class="weui-loading weui-icon_toast"></i>
                <p class="weui-toast__content">正在提交订单</p>
            </div>
        </div>
    </transition>
    <img :src="pixelURL('ZhongDianGong','xiadan')" class="hide">
  </div>
</template>

<script>
import qs from 'qs'
import anime from 'animejs';

export default {
  name: 'index',
  data () {
    return {
        data:{
            token:0,
            service:1,
            type_id:1550735970,
            username:"",
            userphone:"",
            address_street:"",
            address_suburb:"",
            address_postcode:"",
            address_state:"nsw",
            service_date:"",
            service_date_sp:"",
            service_time:"",
            house:"",
            layout:"",
            square:"",
            parking:"",
            message:"",
            messageHolder:"告诉我们更多需求，以便找到最合适您的钟点工"
        },
        isSending:false,
        nextStep:false,
        ifSuburb:false,
        localError:[],
        localErrorShow:false,
        rememberTop:0
    }
  },
  methods: {
    goBack: function() {
        if(this.nextStep){
            this.nextStep = false;
            return false;
        }
        if(this.$route.query.back){
            this.$router.go(-1);
        }
        else{
            this.$router.push('/');
        }
    },
    sleep (time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    suburbSelect: function() {
        this.rememberTop = window.scrollY;
        this.ifSuburb=true;
        document.querySelector("html").classList.remove("service-worker-bg");
        document.querySelector("html").classList.add("grey-background");
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    },
    changeSuburb: function(suburb,postcode) {
        this.data.address_suburb = suburb;
        this.data.address_postcode = postcode;
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-worker-bg");
        this.ifSuburb=false;

    },
    suburbClose: function() {
        this.sleep(10).then(() => {
            document.documentElement.scrollTop = this.rememberTop;
            document.body.scrollTop = this.rememberTop;
        });
        document.querySelector("html").classList.remove("grey-background");
        document.querySelector("html").classList.add("service-worker-bg");
        this.ifSuburb=false;
    },
    submitOrder: function() {
        if(!this.nextStep){
            if(this.checkSubmit()){
                this.nextStep=true;
                return false;
            }
        }
        if(this.nextStep){
            if(this.checkSubmitPost()){
                this.submitOrderPost();
            }
        }
    },
    checkSubmit(){
        this.localError = [];

        if (!this.data.service_date) {
            this.localError.push("请选择服务频次");
        }
        if (this.data.service_date=="sp" && !this.data.service_date_sp) {
            this.localError.push("请选择每周服务次数");
        }
        if (!this.data.service_time) {
            this.localError.push("请填写服务时间段，如：14:00 - 16:00");
        }
        if (!this.data.house) {
            this.localError.push("请选择房屋类型");
        }
        if (!this.data.layout) {
            this.localError.push("请选择房屋户型");
        }
        if (!this.data.parking) {
            this.localError.push("请选择停车位情况");
        }
        if (!this.data.address_street) {
            this.localError.push("请填写 Street 地址信息");
        } else if (this.data.address_street.length < 5) {
            this.localError.push("Street 地址长度过短，请检查是否正确");
        }
        if (!this.data.address_suburb) {
            this.localError.push("请选择地址栏 Suburb");
        }
        if (!this.data.address_postcode) {
            this.localError.push("请填写 Postcode 邮编");
        } else if (this.data.address_postcode.length != 4) {
            this.localError.push("请填写4位数字 Postcode 邮编号码");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    checkSubmitPost(){
      this.localError = [];
      if (!this.data.username) {
          this.localError.push("请填写联系人名");
      }
      if (!this.data.userphone) {
          this.localError.push("请填写联系人手机号");
      }
      if (this.data.userphone.length<8 || this.data.userphone.length>11) {
          this.localError.push("手机号码长度不正确，请检查是否正确");
      }
      if (!this.localError.length) {
        return true;
      }
      else{
        this.localErrorShow = true;
        return false;
      }
    },
    submitOrderPost(){
      if(this.isSending){
        return false;
      }
      else{
        this.isSending = true;
        let that = this;

        //做对象的副本出来
        let orderObject =  JSON.parse(JSON.stringify(this.data));

        if(this.checkLogin()){
            orderObject.token = localStorage.token;
        }
        else{
            orderObject.token = 0;
        }
        
        if(orderObject.service_date=="sp"){
            orderObject.service_date = orderObject.service_date_sp;
        }

        this.axios.post(this.apiURL()+'/Order/createTempOrder', qs.stringify(orderObject))
        .then(function (response) {
          if(response.data.error_code==0){
            that.$router.push('/order-form-success?id='+response.data.data.order_id);
          }
          else{
            alert("提交失败："+response.data.data)
            that.isSending=false;
          }
        })
        .catch(function (error) {
          alert("提交失败，请检查网络并重新尝试")
          that.isSending=false;
          console.log(error);
        });
      }
    },
  },
  created: function () {
    document.querySelector("html").classList.add("service-worker-bg");
    if(this.data.username==""&&localStorage.member_name){
        this.data.username = localStorage.member_name;
    }
    if(this.data.userphone==""&&localStorage.member_phone){
        this.data.userphone = localStorage.member_phone;
    }
  },
  destroyed() {
    document.querySelector("html").classList.remove("service-worker-bg");
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../../assets/css/base.scss";
.main{
    padding:0 10px;
}
.navi{
    display: flex;
    justify-content:space-between;
    padding:0 0 0 0;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    background:rgba(255, 255, 255, 0.9);
    z-index:999;
    span{
        flex: 1;
    }
    div{
        flex:2;
    }
    .close{
        text-align:left;
        font-size:1em;
        .icon-arrow-left{
            margin-right:12px;
            margin-top:12px;
            display:inline-block;
        }
    }
    .icon-arrow-left{
        padding-left:12pt;
    }
    .top-title{
        font-size:0.5em;
        line-height:3.2em;
        color:#444;
        vertical-align:top;
        display:inline-block;
        text-align:center;
    }
}

.container{
  padding-bottom:60px;
}

.container /deep/ .weui-label{
    width:90px;
}

.core{
  background:#f6f6f6;
  border-radius:4px;
  h2{
    padding: 14px 14px 0 14px;
    text-align:center;
  }
}

.logo{
  margin:10vh 0 2vh 6vw;
  img{
    width:46%;
  }
}

.title-sub{
  color: #fff;
  font-size: 0.8em;
  text-align: left;
  margin-bottom:5vh;
}
.park-assist{
    text-align:center;
    color:#fe9567;
}

.container /deep/ .weui-cells_checkbox .weui-check:checked+.weui-icon-checked:before{
  color: #fe9567;
}

</style>



// WEBPACK FOOTER //
// src/pages/service/form/worker.vue